<template>
    <div
        class="dropdown-item d-flex justify-content-between align-items-center"
    >
        <div
            @click="applyFilter"
            class="d-flex align-items-center justify-content-start clickable-item"
        >
            <i class="fa fa-unlock-alt" aria-hidden="true"></i>
            <span class="filter-text">{{ filter.title }}</span>
        </div>

        <b-button
            variant="outline-primary"
            class="text-center"
            @click="buttonHandler"
            v-if="canEditFilter || canEditPrivateFilter"
        >
            <span class="fa fa-pencil fa-md" />
        </b-button>

        <div
            class="dropdown-menu dropdown-menu-custom"
            ref="subDropdown"
            v-bind:class="{
                'dropdown-custom-display-block': isDropdownShow,
                'dropdown-custom-display-none': !isDropdownShow,
            }"
        >
            <b-button
                variant="link"
                class="dropdown-item"
                @click="editFilter()"
            >
                {{ $t('form.button.edit') }}
            </b-button>

            <b-button
                variant="link"
                class="dropdown-item"
                @click="deleteFilter()"
            >
                {{ $t('form.button.delete') }}
            </b-button>
        </div>
    </div>
</template>
<script>
import i18n from '@/i18n'
import notification, { success, danger } from '@/lib/notification'
import { proceedWithConfirmation } from '@/lib/sweet-alert'
import { deleteFilter } from '../../../api'

notification.init()

export default {
    name: 'DropdownItem',
    props: ['filter', 'filterIndex', 'canEditFilter'],
    data() {
        return {
            isDropdownShow: false,
        }
    },
    computed: {
        canEditPrivateFilter() {
            const userId = this.$store.state.currentUser.user.id
            const filterUserId = this.filter.user_id

            return userId === filterUserId
        },
    },
    methods: {
        applyFilter() {
            this.$store.dispatch('setFilter', this.filter)
        },
        buttonHandler(event) {
            event.stopPropagation()
            if (this.isDropdownShow) {
                this.calculateTop()
            }
            this.$emit('toggleSubDropdowns', this.filterIndex)
        },
        calculateTop() {
            const div = document.getElementById('filters-div')
            if (!this.isOverflowing(div)) {
                return
            }
            this.$refs.subDropdown.style.transform = 'translate(-50%, -50%)'
        },
        isOverflowing(element) {
            return element.scrollHeight > element.clientHeight
        },
        editFilter() {
            this.closeSubDropdown()
            this.$router.push({
                path: '/v2/people/list/edit-filter/' + this.filter.id,
            })
        },
        deleteFilter() {
            this.closeSubDropdown()
            proceedWithConfirmation({
                onConfirm: () => deleteFilter(this.filter.id),
                callback: () => {
                    this.$store.dispatch('getFilters')
                    success(
                        i18n.t('notification.deletedSuccessfully', {
                            item: i18n.t('people.filters.title'),
                        })
                    )
                },
                onError: () => danger(),
            })
        },
        closeSubDropdown() {
            this.isDropdownShow = false
        },
    },
}
</script>

<style lang="sass" scoped>
.filter-text
    text-overflow: ellipsis
    display: inline-block
    width: 380px
    overflow: hidden
.clickable-item
    cursor: pointer
.dropdown-menu-custom
    left: 50%
    top: 5%
    transform: translateX(-50%)
.dropdown-custom-display-none
    display: none
.dropdown-custom-display-block
    display: block
</style>
